import React from "react";
import CompanyDetailLayout from "../CompanyDetailLayout";
import RecordAuditPanel from "./RecordAuditPanel";
import RecordFieldValue from "./display/RecordFieldValue";

const RecordDetailBody = ({
  detailModel,
  theme,
  isCompanyDetail,
  companyDisplayRecord,
  auditMetadata,
  canEdit,
  onOpenLinkedRecord,
}) => (
  <div className="relative px-6 py-6">
    {auditMetadata ? <RecordAuditPanel auditMetadata={auditMetadata} canEdit={canEdit} /> : null}

    {isCompanyDetail ? (
      <CompanyDetailLayout record={companyDisplayRecord} onOpenLinkedRecord={onOpenLinkedRecord} />
    ) : (
      detailModel?.sections?.map((section) => (
        <div key={section.title}>
          <h3 className="border-b border-slate-800/90 pb-2 text-base font-bold tracking-wide text-white">
            {section.title}
          </h3>
          <div className="mt-3 space-y-3">
            {section.fields.map((field) => (
              <div
                key={`${section.title}-${field.label}`}
                className="flex flex-col gap-2 border-b border-slate-900/80 pb-3 last:border-b-0 last:pb-0 md:flex-row md:justify-between md:gap-6"
              >
                <p className="shrink-0 text-xs font-medium uppercase tracking-[0.12em] text-slate-500 md:w-44">
                  {field.label}
                </p>
                <RecordFieldValue field={field} theme={theme} onOpenLinkedRecord={onOpenLinkedRecord} />
              </div>
            ))}
          </div>
        </div>
      ))
    )}

    {detailModel?.links?.length ? (
      <div className="mt-6">
        <h3 className="border-b border-slate-800/90 pb-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-500">
          Public Links
        </h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {detailModel.links.map((link) => (
            <a
              key={`${link.label}-${link.href}`}
              href={link.href}
              target="_blank"
              rel="noreferrer"
              className={`inline-flex items-center rounded-full border px-3 py-1.5 text-xs font-medium transition-colors hover:bg-slate-900 ${theme.idBadge}`}
            >
              {link.label}: {link.text}
            </a>
          ))}
        </div>
      </div>
    ) : null}
  </div>
);

export default RecordDetailBody;
